import React from 'react';
import styled from 'styled-components';
import { renderContent, renderContentWithParams } from 'utilities/content/content-utilities';
import IconShoppingBasketAdd from '@tvg/fuse-icons/lib/ShoppingBasketAdd';
import IconPersonAuthenticate from '@tvg/fuse-icons/lib/PersonAuthenticate';
import IconAccountBalanceWallet from '@tvg/fuse-icons/lib/AccountBalanceWallet';
import IconDescription from '@tvg/fuse-icons/lib/Description';
import IconTakeThreeSmall from '@tvg/fuse-icons/lib/TakeThreeSmall';
import Take3Breakdown from 'components/Take3Breakdown/Take3Breakdown';

import {
  DialogPanel,
  DialogSection,
  DialogSectionHeading,
  DialogSectionSubHeading,
  DialogList,
  DialogListItem,
  AprText,
  HowToUseSection,
  HowToUseList,
  HowToUseStep,
  DialogSectionIcon,
} from '../styles/VeryPayDialogStyles';

const Take3BreakdownContainer = styled.div`
  margin: var(--spacing-space24) 0;
`;

type Props = {
  active: boolean;
  apr: string;
  firstPayment: string;
  secondPayment: string;
  thirdPayment: string;
  nonCreditAccountUser: boolean;
  productPrice: string;
  transitionDuration: number;
};

function Take3Page(props: Props) {
  const {
    active,
    apr,
    firstPayment,
    secondPayment,
    thirdPayment,
    nonCreditAccountUser,
    productPrice,
    transitionDuration,
  } = props;

  return (
    <DialogPanel active={active} transitionDuration={transitionDuration} dataTestId="verypay_dialog_take3">
      <DialogSection>
        <DialogSectionIcon
          removeMargin
          width="28px"
          height="28px"
          icon={<IconTakeThreeSmall />}
          alt={renderContent('verypay.dialog.take3.dialogHeading')}
        />

        <Take3BreakdownContainer data-testid="verypay_dialog_take3_cost-breakdown">
          <Take3Breakdown
            price={productPrice}
            todaysPayment="£0"
            firstPayment={firstPayment}
            secondPayment={secondPayment}
            thirdPayment={thirdPayment}
          />
        </Take3BreakdownContainer>

        <DialogSectionSubHeading tag="h4" size="4">
          {renderContent('verypay.dialog.take3.info.heading')}
        </DialogSectionSubHeading>

        <DialogList>
          <DialogListItem>{renderContent('verypay.dialog.take3.info.point1')}</DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.take3.info.point2')}</DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.take3.info.point3')}</DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.take3.info.point4')}</DialogListItem>
        </DialogList>

        {apr && nonCreditAccountUser && (
          <AprText>
            {renderContentWithParams({
              id: 'verypay.dialog.take3.apr',
              params: [apr],
            })}
          </AprText>
        )}
      </DialogSection>

      <HowToUseSection>
        <DialogSectionHeading
          tag="h4"
          size="4"
          dangerouslySetInnerHTML={{
            __html: renderContent('verypay.dialog.take3.howToUse.heading'),
          }}
        />

        <HowToUseList>
          <HowToUseStep
            icon={<IconShoppingBasketAdd />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.take3.howToUse.step1.heading')}
            description={renderContent('verypay.dialog.take3.howToUse.step1.description')}
          />

          <HowToUseStep
            icon={<IconPersonAuthenticate />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.take3.howToUse.step2.heading')}
            description={renderContent('verypay.dialog.take3.howToUse.step2.description')}
          />

          <HowToUseStep
            icon={<IconAccountBalanceWallet />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.take3.howToUse.step3.heading')}
            description={renderContent('verypay.dialog.take3.howToUse.step3.description')}
          />

          <HowToUseStep
            icon={<IconDescription />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.take3.howToUse.step4.heading')}
            description={renderContent('verypay.dialog.take3.howToUse.step4.description')}
          />
        </HowToUseList>
      </HowToUseSection>
    </DialogPanel>
  );
}

export default Take3Page;
